import type {
    KEScore,
    PerseusRenderer,
    PerseusScore,
    UserInputMap,
} from "@khanacademy/perseus-core";
import {mapErrorToString} from "@khanacademy/perseus/strings";
import {
    scorePerseusItem as perseusScorePerseusItem,
    ScoringUtil,
    type ServerItemRendererComponent,
} from "@repo/component-perseus/perseus";
import Log, {Errors} from "@repo/logging";
import {RequestInfo} from "@repo/shared-core";

import {perseusStrings} from "./perseus-strings-lingui.tsx";

/**
 * Helper to score a Perseus item without having
 * to think about strings and locale
 */
export default function scorePerseusItem(
    question: PerseusRenderer,
    userInput: UserInputMap,
): PerseusScore {
    const translatedPerseusStrings = perseusStrings();
    const score = perseusScorePerseusItem(
        question,
        userInput,
        RequestInfo.kaLocale,
    );

    let modifiedMessage = "";
    try {
        modifiedMessage = mapErrorToString(
            score.message,
            translatedPerseusStrings,
        ) as any;
        score.message = modifiedMessage;
    } catch (err) {
        Log.error(
            "Failed to map Perseus error code to error message",
            Errors.Internal,
        );
    }

    return score;
}

/**
 * This come from a place of fear. I don't think we need to
 * do the `maxCompatGuess` thing, but I can't figure out what might
 * be using this data so I'm trying to keep it the same as it was.
 */
export function convertScoreToKeScore(
    score: PerseusScore,
    renderer: ServerItemRendererComponent,
): KEScore {
    // Continue to include an empty guess for the now defunct answer area.
    // TODO(alex): Check whether we rely on the format here for
    //             analyzing ProblemLogs. If not, remove this layer.
    const maxCompatGuess = [renderer.getUserInputLegacy(), []];
    return ScoringUtil.keScoreFromPerseusScore(
        score,
        maxCompatGuess,
        renderer.questionRenderer.getSerializedState(),
    );
}
